import { autoinject, computedFrom } from 'aurelia-framework';
import { WidgetController } from 'controls/as-widget-container';
import { WidgetBase } from 'support/base_classes/widget-base';
import { CountryWrapper } from 'model/support-types';
import { KeywordsService } from 'services/keywords-service';
import { ValidationRules } from 'aurelia-validation';

@autoinject
export class AdminCountrySelectorWidget extends WidgetBase<CountryWrapper, WidgetController> {
  constructor(private keywords: KeywordsService) {
    super();
  }

  changed() {
    ValidationRules
      .ensureObject<CountryWrapper>().required()
      .ensure(model => model.country).displayName('Country').required()
      .on(this.model);
  }

  @computedFrom('keywords.countries', 'model.country')
  get countries() {
    return this.keywords.ensureItem(this.keywords.countries, this.model.country);
  }
}
